import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'es'],
    fallbackLng: 'en',
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    ns: ['common', 'landing', 'auth', 'dashboard', 'study', 'pricing', 'settings', 'modals'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Cache-bust the locale JSONs so browsers don't serve a stale copy after a
      // deploy that adds new keys. Symptom of the missing bust: literal keys like
      // "flashcards.crud.edit_button" rendered in the UI until the user hard-
      // refreshed, because the browser-cached study.json predated PR #43.
      // BUMP `v` every time anything under public/locales/ changes.
      // TANDA 11 (firma #180): la tarjeta de Diagnóstico vuelve a Ajustes con
      // candado de administrador y estrena TRES claves por idioma bajo
      // `diagnostics` en settings.json. v80 -> v81.
      // TANDA 24 (firmas #220/#221): los avisos del banco y de grupos estrenan
      // SIETE claves por idioma bajo `errors` en common.json —el canal por el que
      // el servidor deja de hablarle en inglés a una app en español— más el bloque
      // `a11y` con la etiqueta de la X de los modales. v81 -> v82.
      // TANDA 26 (firma #234): EL CARRIL DEL PROFESOR ESTRENA SU SEGUNDO IDIOMA.
      // Casi cien llaves nuevas por idioma bajo `groups.bank.*` —el banco, los
      // temas, la publicación y la curación—, cuatro para el borrado de grupo,
      // siete avisos de servidor bajo `errors`, y OCHO LLAVES MUERTAS RETIRADAS
      // (las que la firma #118 dejó huérfanas al sustituir los copys de estado
      // por el chip de tres palabras). Un locale que ENCOGE también necesita
      // bust: el navegador que se quedara con el viejo seguiría sirviendo las
      // ocho. v82 -> v83.
      // TANDA 28b-fix2 (PR #331): `pricing.headings.subtitle` SE RETIRA en
      // los dos idiomas —la frase «Todos los planes incluyen…» prometía en prosa
      // lo que la tabla de abajo ya dice con un renglón por capacidad—. Un locale
      // que ENCOGE también necesita bust, por lo mismo que la v82 -> v83: el
      // navegador que se quedara con el viejo seguiría sirviendo la llave
      // retirada, y aquí eso significa seguir pintando una frase que ya no
      // existe en ninguna parte del código. v90 -> v91.
      // TANDA 28b-fix3 (firma #263): `pricing.referral` estrena DOS llaves, la nota del
      // precio con descuento (mensual y anual). Un locale que CRECE también necesita
      // bust: el navegador que se quedara con el viejo pediría la nota, no la
      // encontraría, y pintaría la llave cruda —«pricing:referral.price_note_monthly»—
      // justo debajo del precio, que es la única línea que le dice a quien tiene cupón
      // que el 20% es del primer cobro. v91 -> v92.
      // TANDA 28d (§F): `pricing.plans.free.description` y `pricing.plans.pro.description`
      // SE RETIRAN en los dos idiomas — los dos párrafos de dentro de las tarjetas de
      // plan se van de las tres superficies donde se pintaban. Locale que ENCOGE, mismo
      // motivo que la v90 -> v91: el navegador que se quedara con el JSON viejo lo
      // seguiría sirviendo, y aunque aquí el consumidor ya no existe, la regla de la casa
      // no admite excepciones por «esta vez no se nota». v92 -> v93.
      // TANDA 29 (#272): el selector de temas por sesión estrena CUATRO llaves por
      // idioma en `center.settings` (la etiqueta del renglón, "Todos los temas" y
      // el par singular/plural de "{{count}} de {{total}} temas") y OCHO en el
      // bloque nuevo `center.topics` (título de la ventana, su frase de ayuda, los
      // dos pares de plurales de los conteos y los botones Limpiar / Listo). Un
      // locale que CRECE necesita bust por lo mismo que la v91 -> v92: el navegador
      // que se quedara con el JSON viejo pediría llaves que no existen en él y
      // pintaría el nombre crudo —«study:center.settings.topics_label»— como
      // etiqueta del renglón. v93 -> v94.
      // TANDA 31 (#280/#281): `study.json` cambia en las dos direcciones — se van
      // TRES llaves de `center.settings` (la etiqueta del renglón, "Todos los
      // temas" y la nota de la adaptativa, que el botón y el párrafo del modo
      // dejaron sin consumidor) y CAMBIA el texto de `center.adaptive_description`.
      // Un locale que ENCOGE necesita bust por el motivo simétrico al de la v93 ->
      // v94: el navegador que se quedara con el JSON viejo seguiría sirviendo un
      // párrafo que ya no es el que producto ratificó. v94 -> v95.
      // HOTFIX RACIONALES (#338): `study.json` CRECE en los dos idiomas — entra
      // `exam.results.rationale_correct_explained`, la etiqueta del tercer
      // camino del bloque de racionales de los resultados del examen. El
      // navegador que se quedara con el JSON viejo pediría una llave que no
      // existe en él y pintaría el nombre crudo —«study:exam.results.
      // rationale_correct_explained»— justo donde antes mentía diciendo "Por
      // qué es correcta" sobre una respuesta fallada: cambiar una mentira por
      // una clave cruda no es arreglarlo. v95 -> v96.
      // TANDA 32 (#297): `common.json` CRECE en los dos idiomas — entra
      // `logout_offline_notice`, el aviso de que cerrar sesión sin señal deja
      // el aparato sin credenciales y volver a entrar va a necesitar internet.
      // Un locale que CRECE necesita bust por lo mismo que la v93 -> v94: el
      // navegador que se quedara con el JSON viejo pediría una llave que no
      // existe en él y pintaría el nombre crudo —«common:logout_offline_notice»—
      // dentro del toast, justo en el momento en que el usuario acaba de
      // quedarse sin sesión y sin red para recuperarla. v96 -> v97.
      // T6 (#286): `dashboard.json` CRECE con las dos puertas nuevas del banco del
      // profesor — los dos bloques `groups.bank.youtube` y `groups.bank.audio`, el
      // rango en minutos (`temas.min_range`) y el aviso de lo terminado desde la
      // última visita (`doc.since_last_visit`). Un locale que crece necesita bust
      // por lo de siempre: el navegador que se quedara con el JSON viejo pintaría
      // la llave literal («groups.bank.audio.upload_btn») en el botón de subir una
      // grabación. v97 -> v98.
      // TANDA 33b (#304/#305): el copy de liga inválida del profe toma el del
      // alumno, y nace el título del plegable del código. v98 -> v99.
      // OCR-1 (#307/#308/#310): mueren `bank_pdf_scanned` y `bank_doc_too_long`
      // en common.json; nacen `bank_pdf_too_many_pages` y
      // `bank_material_sin_texto`. v99 -> v100.
      // OCR-ALUMNO (PR #347): nacen `doc_scanned_too_many_pages`, `doc_too_many_photos`
      // y `dashboard:fotos.*`; cambian `doc_no_text_for_study` y `formats_hint`. v100 -> v101.
      // REMATES-OCR-ALUMNO (PR #348): nacen `doc_very_little_text` (#333) y
      // `dashboard:fotos.desmarcar_todas` / `marcar_todas` (#332). v101 -> v102.
      // PROFE-DESCARGAS-REMATES-ALUMNO (PR #349): cambia `settings:referral.body` (A-4);
      // en `dashboard.json` muere `groups.bank.youtube.choose_language` y nacen
      // `choose_language_title/_desc/_search`, `loading` (P-2) y
      // `groups.bank.curacion.export_word` (P-3). v102 -> v103.
      // REMATES-350 (PR #351): cambia `common:errors.bank_material_sin_texto` (R-1,
      // dice el mínimo de 200); en `dashboard.json` muere
      // `groups.bank.doc.since_last_visit` (R-2) y nace el bloque
      // `groups.bank.subida.*` (R-4: botón y toast de subida con avance, web y app,
      // «listo» y «espera»). v104 -> v105.
      // REBANADAS-BANCO (PR #352): nacen `common:errors.bank_subida_caducada`,
      // `bank_rebanada_corrupta` y `bank_subida_incompleta` (firma #352, los tres
      // avisos de la subida por rebanadas). v105 -> v106.
      // INFRA-1 (PR #353, firma #353 d): el chip del audio deja de inventarse una
      // causa. `dashboard:groups.bank.audio.chip_queued` CAMBIA de texto y nace su
      // par de la app, `chip_queued_app`. Es el ÚNICO texto nuevo de la tanda; los
      // demás avisos (413 de la rebanada, R2 sin configurar, sesión terminada)
      // reusan códigos y conductas que ya existían. v106 -> v107.
      // TARJETA DEL ALUMNO (tanda 1, firmas #367/#368/#369): nace
      // `dashboard:doc_card.por_confirmar_line`, la línea que la tarjeta de un
      // escaneado ya leído pinta para decir que espera al alumno y que caduca a
      // los 7 días. Es la ÚNICA llave nueva de la tanda: el chip reusa
      // `doc_card.status.uploaded` y el botón reusa `doc_card.actions.process`,
      // que ya decían «Listo para procesar» y «Procesar». v107 -> v108.
      // INFRA-2 (#363/#365): `dashboard.json` CRECE con seis llaves —el chip
      // «Sin material para preguntas» con su línea, y los cuatro avisos del
      // botón «Generar»—. Un locale que crece necesita bust por lo mismo de
      // siempre: el navegador que se quedara con el viejo pediría el chip nuevo
      // y pintaría la llave cruda. v108 -> v109.
    // BLOG-1 (#438, v115 -> v116): nace `landing:footer.blog`, el enlace "Blog" del
    // pie de la web publica, en EN y ES. Es la UNICA llave del blog que pasa por
    // i18next: el resto del chrome del blog lo sirve el backend desde
    // `backend/blog/textos_blog.json`, porque el blog es HTML de verdad y no React.
    // BLOG-1-CIERRE (#454 + S6, v116 -> v117): `landing.json` CAMBIA en los dos
    // idiomas --- el ultimo renglon de la tarjeta Pro deja de prometer el «Readiness
    // Score», que no es de Pro sino de TODOS los planes (la tabla comparativa de
    // `/pricing` y `/upgrade` ya lo pintaba con palomita en las dos columnas) --- y
    // `auth.json` CRECE con TRES llaves por idioma: `login.meta_title`,
    // `signup.meta_title` y `forgot_password.meta_title`, el titulo de la PESTANA de
    // las tres pantallas publicas de sesion, que se quedaba en ingles para un usuario
    // en espanol (medido con Chrome sobre un build real). Uno que CAMBIA y otro que
    // CRECE: sin bust, el navegador con el JSON viejo seguiria pintando el renglon que
    // promete de mas, y pediria las tres llaves nuevas sin encontrarlas.
    // AJUSTES-1-2-1 (#448 + G6, v117 -> v118): `common.json` CRECE con
    // `errors.reason_text_too_long` — el aviso del tope de 2,000 caracteres del
    // comentario de cancelación, que hasta hoy se recortaba en silencio — y
    // `dashboard.json` CRECE con `image_preview.slide_alt` y
    // `image_preview.slide_caption`, el par ratificado para las miniaturas de un
    // PPT («Diapositiva {{page}}» / «Slide {{page}}»), que el PDF no comparte.
    // Los dos CRECEN: sin bust, el navegador con el JSON viejo pediría las tres
    // llaves nuevas y pintaría la llave cruda.
    // REMATES-1-2-1 (B, v118 -> v119): `common.json` CRECE con
    // `errors.reason_required`, el par ratificado en #433 («Pick a reason to
    // continue.» / «Elige un motivo para continuar.») que hasta hoy no existía:
    // la puerta de Apple ahora recibe ese 400 y lo pinta por su código. Sin bust,
    // el navegador con el JSON viejo pintaría el inglés crudo del servidor.
    // REMATES-1-2-1 (remate, v119 -> v120): `common.json` CRECE con
    // `errors.pay_plan_restored` («Your Pro plan has been restored. No changes will
    // be made.» / «Tu plan Pro se mantiene. No se hará ningún cambio.»), el aviso
    // de deshacer la cancelación, que viajaba en inglés crudo y ahora llega con su
    // código hermano. Sin bust, el navegador con el JSON viejo no encontraría la
    // llave y pintaría el inglés del servidor.
    // REMATES-2 (C, v120 -> v121): `common.json` CRECE con
    // `errors.reason_text_required` ("To cancel with that reason, please write a few
    // words." / "Para cancelar con ese motivo, escribe al menos unas palabras."), el
    // par ratificado el 23-sep: lo pinta la ventana del motivo al tocar el boton
    // apagado con el texto corto, y el interceptor cuando el servidor contesta ese
    // 400. Sin bust, el navegador con el JSON viejo pintaria el ingles crudo.
    // T7-1B (T8, v121 -> v122): `common.json` CRECE con
    // `errors.group_material_not_available` ("This material has expired and can't
    // be studied." / "Este material ya caducó y no se puede estudiar."), el 403 de
    // estudiar una card caducada; y `dashboard.json` CRECE con `grupos_alumno.*` (la
    // tarjeta del grupo en el Panel del alumno), cuatro llaves de
    // `groups.bank.publicar` (nombre y fecha de la card) y siete de
    // `groups.bank.temas` (la lista "Cards publicadas" y el aviso
    // `caduca_invalida`). Sin bust, el navegador con el JSON viejo pintaria la
    // llave cruda.
    // T7-1C (P, v122 -> v123): `dashboard.json` CRECE con `grupos_alumno.cards_one`
    // y `grupos_alumno.cards_other` ("1 card" / "{{count}} cards", iguales en los
    // dos idiomas), el texto 22: la linea de informacion de la tarjeta del grupo en
    // el Panel del alumno. Sin bust, el navegador con el JSON viejo pintaria la
    // llave cruda.
    // SERIES-7 (H, v123 -> v124): `dashboard.json` CRECE con `auto_split.s7.*` (la
    // ventana del documento grande dice cuantas partes ahora y la combinacion exacta),
    // `partes_padre.*` y `tarjeta_plegable.*` (la tarjeta padre de las partes y el
    // cuadro de buscar), `youtube.no_es_youtube` y `youtube.no_se_pudo_leer` (#493), y
    // CAMBIA `groups.bank.publicar.caduca_ayuda` (#483); `study.json` CRECE con
    // `center.toasts.cards_sin_flashcards` (#486). Sin bust, el navegador con el JSON
    // viejo pintaria la llave cruda.
    // ajustes-1-3-0 (T, 25-sep-2026): v124 -> v125. `dashboard.json` GANA groups.buscar_*,
    // groups.bank.youtube.add_btn_corto, tarjeta_plegable.buscar/tema_coincide/buscando_temas,
    // partes_padre.conteo_* y parte_bloqueada*, auto_split.s7.leyenda_ahora/_pendientes/_despues y
    // parts_map.aria_overflow/nombre_*; CAMBIA s7 (T1/T2) y PIERDE s7.leyenda_desborde* y
    // doc_card.por_confirmar_line; `study.json` cambia center.toasts.cards_sin_flashcards (T3);
    // `modals.json` gana credit_pack.prices_in_usd y badges.best_value; `pricing.json` gana
    // packs.best_value. Sin bust, la app con el JSON viejo pintaria llaves crudas.
    // remates-1-3-0b (25-sep-2026): v125 -> v126. `dashboard.json` GANA toasts.leave_app y
    // toasts.leave_tab (#512, la frase de salida del aviso de subida) y
    // doc_card.actions.tap_to_process / click_to_process (#513, el boton ancho). Sin bust, el
    // navegador con el JSON viejo pintaria la llave cruda.
    // remates-1-3-0c (26-sep-2026): v126 -> v127. `dashboard.json` GANA tarjeta_plegable.temas_fallo
    // (Q2, el aviso cuando los temas no se pudieron cargar), groups.bank.youtube.no_es_youtube /
    // no_se_pudo_leer / duplicado (Q5, los avisos del alumno en el campo del profe) y
    // groups.bank.temas.cards_conteo_one/_other (Q6); PIERDE las tres opciones del selector de
    // orden de la tarjeta plegable (Q7, C15) y groups.bank.youtube.no_transcript / unavailable (Q5). Sin bust, el
    // navegador con el JSON viejo pintaria la llave cruda.
    // t7-2b (B, 27-sep-2026): v130 -> v131. `dashboard.json` GANA groups.avance.chat.* (#518, los
    // textos del cajon "Preguntale al panel"). Sin bust, el navegador con el JSON viejo pintaria la
    // llave cruda.
    // t7-2b remate (R3, 27-sep-2026): v131 -> v132. `dashboard.json` CAMBIA
    // groups.avance.chat.adjuntar: el espacio entre "5" y "MB" pasa a no separable (R3b), para
    // que no quede "5" en un renglon y "MB" en el otro. Sin bust, el navegador con el JSON viejo
    // seguiria partiendolo.
    // t7-2c (B9, 28-sep-2026): v132 -> v133. `dashboard.json` cambia la cara del avance del grupo
    // (#532): GANA groups.avance.barra_titulo, sub.*, riesgo_titulo, temas_titulo, mejora_*, ayuda_*,
    // kpi_*, eran_*, mejoraron, mejoro_*, reconocelos, sin_semana, nadie_*, ningun_tema_datos,
    // ver_por_card, riesgo.*, le_cuesta_a_*, para_tu_clase, empieza, la_dificil, dificultad.*,
    // la_fallan_q_*, la_fallo_el_unico, discutan, eligen, mayoria_elige, eligen_otra, por_que,
    // revisa_*, sospechosa, dif_*, pocos, caduca_*, caduco_el, practicaron_de_*, mas_fallan,
    // la_fallan_chip_*, preparacion, acierta, caducada, resumen_por_card, toca_card y
    // chat.chip_mejoro (B8); CAMBIA seccion.tabla, cuadro (sin "ha visto") y ver_alumnos_* (con la
    // flecha); PIERDE lo de la cara v1 (listos, total_preguntas, evidencia, el plan de la portada,
    // "De un vistazo" y sus tarjetas). Sin bust, el navegador con el JSON viejo pintaria la llave cruda.
    // t7-2d (C8, 29-sep-2026): v133 -> v134. `dashboard.json` cambia la portada del avance del grupo
    // (#542 a #549): GANA groups.avance.riesgo_titulo_de, motivo.*, x_de_y, recordar_todos,
    // recordado_hoy, ver_detalle_de, ver_como_explicarla, otros_temas_rojos, ver_todos_los_temas,
    // sin_pregunta, esta_en_pagina(s), a_nadie_le_cuesta, van_a_medias_*, la_que_mas_fallan,
    // contorno_*, pideles_*, todo_verde, avanzar, nadie_esta_semana, mejora_fila.*,
    // grupo_practicaron, mejoraron_de_*, ver_todos, nadie, nombres.*, aviso.*, sin_motivo,
    // buscar_por_nombre, practico_dias_*, no_se_pudo_mandar, leyenda_accion.*, practicaron_nadie y
    // dif_partes.*; CAMBIA ayuda_temas y ayuda_mejora; PIERDE eran_*, ver_por_card, reensenar_vacio,
    // practicas_*, nunca_han, practicando, kpi_practicaron, recordatorio_enviado, de_y y mejoraron
    // (v6 seccion 11.1). Sin bust, el navegador con el JSON viejo pintaria la llave cruda.
    // t7-2d remate (B3, 29-sep-2026): v134 -> v135. `dashboard.json` GANA groups.avance.ver_quienes
    // (#552, el renglon de riesgo desplegable; "Ocultar" reusa grupos_alumno.aria_cerrar, el mismo par).
    // Sin bust, el navegador con el JSON viejo pintaria la llave cruda.
    // t7-3 (P3, 29-sep-2026): v135 -> v136. `dashboard.json` CAMBIA el separador de cinco hojas de
    // groups.avance.* (#556, regla 22: sin punto medio): barra_titulo (punto y espacio), empieza y
    // la_que_mas_fallan (parentesis), cuadro y cuadro_gris (dos puntos, punto y coma de datos). Las
    // palabras no cambian. Sin bust, el navegador con el JSON viejo pintaria el separador viejo.
    // t7-3 remate (R2, 30-sep-2026): v136 -> v137. El barrido COMPLETO del punto medio (orden de
    // Carlos del 29-sep): `common.json`, `dashboard.json`, `landing.json` y `settings.json` CAMBIAN
    // el separador de 57 renglones (coma entre datos; punto y espacio antes de un rotulo con
    // mayuscula). Las palabras no cambian. Sin bust, el navegador con el JSON viejo pintaria el
    // separador viejo.
    // t7-3 remate 2 (R1 a R7, 30-sep-2026): v137 -> v138. `dashboard.json` CAMBIA las hojas de
    // groups.avance.* que decian "card" (ahora "publicacion"), la frase de dificultad en renglones,
    // la linea de las paginas del tema, el enlace "Ver como explicarla" y la ayuda del riesgo, y GANA
    // groups.avance.publicaciones y ocultar_como_explicarla. Sin bust, el navegador con el JSON viejo
    // pintaria la palabra vieja y las llaves nuevas crudas.
    // post-t7-1 (M5, 8-oct-2026): v141 -> v142. Los locales de esta corrida: el panel del profe (A), los textos del
    // alumno (C), el escaneado que no alcanza (H), los formatos del profe (I2), la bienvenida de la app (J), sin guion
    // largo (K, 23 textos por idioma) y fuera los residuos de groups.avance (M2). Sin bust, el navegador con el JSON
    // viejo pintaria las llaves nuevas crudas y el signo viejo.
    // cierre de post-t7-1 (F1, 9-oct-2026): v142 -> v143. La cara de Pendientes lleno del escaneado entero dice su
    // frase propia (#603, auto_split.entero.lleno).
    // POST-T7-2B (#615 y otros, v144 -> v145, 14-oct-2026): `common.json` GANA prod.codigo.nosalio (el codigo
    // que no salio, en el registro y en la ventana de registro del Panel). Los demas bloques de la corrida (unirse,
    // crear grupo, el aviso verde, el admin) agregan sus llaves bajo este MISMO bust. Sin bust, el navegador con el
    // JSON viejo pintaria la llave cruda.
    // remate de post-t7-2b (R4, v145 -> v146, 14-oct-2026): `dashboard.json` GANA auto_split.s7.oferta_todas_one
    // (el documento de una sola pieza: "lo procesas ahora"). Sin bust, el navegador con el JSON viejo pintaria
    // "las 1 partes ahora".
    // post-t7-2c (v146 -> v147, 14-oct-2026): `dashboard.json` GANA groups.avance.volver_a (el boton de
    // regresar del panel) y opinion.* (el cuadro de opinion); `common.json` GANA red.* (la red contra las
    // caidas) y los codigos feedback_* y referrals_closed; se van las llaves del programa de referidos
    // (auth, dashboard, pricing, settings). Sin bust, el navegador con el JSON viejo pintaria la llave cruda.
    // el remate de post-t7-2c (v147 -> v148, 15-oct-2026): `common.json` GANA nav.earn_credits (el renglon
    // del menu y el titulo de la pantalla nueva) y `dashboard.json` GANA opinion.creditada. Sin bust, el
    // navegador con el JSON viejo pintaria la llave cruda.
    // pantallas-alumno (v149 -> v150, 19-oct-2026): las nueve pantallas del alumno. `study.json` GANA
    // center.missing_questions.*, exam.toasts.time_up, flashcards.summary.remaining_more y
    // readiness.topics_studied_one; `settings.json` GANA section_load_failed y subscription.apple_managed_web;
    // `auth.json` GANA signup.signup_guest_reason; `common.json` GANA errors.auth_password_min_8 y
    // auth_new_password_min_8; cambian la recomendacion sin Bloom y los textos de la contrasena (6 a 8); se
    // van material_notice, no_questions_screen, flashcards.empty_body, opinion.creditada y los de Switch to
    // Free. Sin bust, el navegador con el JSON viejo pintaria las llaves nuevas crudas.
    // smoke-alumno (v150 -> v151, 20-oct-2026): `common.json` GANA errors.feedback_rate_limited_minute y
    // errors.feedback_rate_limited_day (S12, los dos frenos de las opiniones con su propio aviso). Sin bust,
    // el navegador con el JSON viejo pintaria el codigo crudo.
    // post-t7-2-dinero (v151 -> v152, 21-oct-2026): `settings.json` GANA subscription.pago_fallido y
    // pago_fallido_btn (el aviso de Actualizar tarjeta), `dashboard.json` GANA toasts.lote_no_cabe_one y
    // lote_no_cabe_other (F1) y `common.json` GANA errors.pay_update_card_first (A6). Sin bust, el navegador con
    // el JSON viejo pintaria las llaves crudas.
    // tutor-2 (v153 -> v154, 21-oct-2026): `study.json` GANA tutor.mid.show_question (C.8, firma #678).
    // tutor-3 remate (v154 -> v155, 22-oct-2026): cambian 23 VALORES por idioma de `study.json` y `common.json`
    // (el tutor se llama Sabi, firma #693); ninguna llave nace ni se va.
    // alumno-m4 (v155 -> v156, 22-oct-2026): cambian DOS valores en espanol de `study.json`
    // (tutor.empty.greeting y greeting_guest: Sabi ya no dice tutor); ninguna llave nace ni se va.
    // seo-agencia (v156 -> v157, 24-oct-2026): cambia UN valor por idioma de `landing.json`
    // (faq.items.3.a: los formatos con escaneados, fotos y YouTube); ninguna llave nace ni se va.
    // precios-sabi (v157 -> v158, 25-oct-2026): dos llaves nuevas en `pricing.json` (features.tutor_free
    // y tutor_pro) y cambian valores de `pricing`, `landing`, `modals` y `settings` (Sabi en lo que trae Pro).
    // camara-pills (v158 -> v159, 26-oct-2026): cambia el valor de `study.tutor.composer.doc` (es y en), la
    // etiqueta del clip de Sabi, que desde hoy sube documentos o fotos.
    // remate de camara-pills (v159 -> v160, 26-oct-2026): nace `study.tutor.chip.exam_insight` (es y en), el chip
    // de los resultados del examen; ninguna otra llave cambia.
      queryStringParams: { v: '165' },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang_preference',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`[i18n] Missing key: ${ns}:${key} (lng=${lngs.join(',')})`);
      }
    },
  });

export default i18n;
